'use client';

import React, { useState } from 'react';
import queryString from 'query-string';
import { HeroHeaderSection } from '../../../../components/HeroHeaderSection';
import { DataTestIds } from '../../../../constants/data-testids';
import { WagWebAppUrl } from '../../../../constants/app';
import { QueryStringKeys } from '../../../../constants/query-string-keys';
import backgroundDesktop from '../../../../assets/hero-header-backgrounds/banner-photo-desktop_2x.png';
import backgroundMobile from '../../../../assets/hero-header-backgrounds/banner-photo-mobile_2x.png';
import { Flex } from '../../../../wag-react/next-components/Flex';
import { Box } from '../../../../wag-react/next-components/box';
import { TextField } from '../../../../wag-react/core-components/textfield';
import { Button } from '../../../../wag-react/next-components/button';
export const WellnessHeroHeaderSectionV2 = () => {
  const [textFieldValue, setTextFieldValue] = useState('');
  const [textFieldError, setTextFieldError] = useState(null);
  const handleOnButtonClick = () => {
    if (!textFieldValue) {
      setTextFieldError("Please enter your pet's name to continue");
      return;
    }
    const heroCtaUrl = queryString.stringifyUrl({
      url: `${WagWebAppUrl.WellnesssAccountFlow}`,
      query: {
        [QueryStringKeys.PetName]: textFieldValue
      }
    });
    window.open(heroCtaUrl);
  };
  return <HeroHeaderSection justifyContent="center" containerProps={{
    paddingTop: '8px'
  }} backgroundImage={[`url(${backgroundMobile})`, null, `url(${backgroundDesktop})`, null]} ctaBlock={<Flex flexDirection="column" alignItems="center" justifyContent="center">
          <Box textAlign="center" borderRadius="8px">
            <Box justifyContent="center" backgroundColor="white" borderColor={textFieldError && 'red'} borderRadius="8px" width="335px" marginTop={['4px', '32px']}>
              <TextField fullWidth label="What’s your furry friend’s name?" placeholder="What’s your furry friend’s name?" error={textFieldError} helperText={textFieldError} inputProps={{
          backgroundColor: 'white',
          borderRadius: '8px',
          height: '20px',
          padding: '4px'
        }} helperTextProps={{
          fontSize: '14px',
          marginTop: '0px',
          backgroundColor: ['#ececef', '#e5e4e6']
        }} data-testid={DataTestIds.WagWellnessPlansPage.HeroHeader.TextField} onChange={event => setTextFieldValue(event.target.value)} />
              {/* // Error placeholder box to reduce CLS */}
              {!textFieldError && <Box marginTop="30px" backgroundColor={['#ececef', '#e5e4e6']} />}
            </Box>
            <Button mt="8px" variant="contained" size="medium" textAlign="center" onClick={handleOnButtonClick} data-testid={DataTestIds.WagWellnessPlansPage.HeroHeader.HeroCta}>
              Get started
            </Button>
          </Box>
        </Flex>} darkText height={['580px', '840px', '552px', '756px']} titleText="Your pet's wellness starts here" titleTextProps={{
    mx: ['auto', 'null'],
    justifySelf: 'center',
    my: '8px',
    textAlign: ['center', 'center', 'center'],
    maxWidth: ['268px', '600px', '1000px'],
    color: '#474747'
  }} subtitleText="Interested in a wellness plan to help you pay for routine vet bills? Tell us more about your pet and we’ll recommend the paw-fect plan for your needs!" subtitleTextProps={{
    mx: ['auto', 'null'],
    paddingRight: '0px',
    my: '4px',
    fontSize: ['18px', '20px'],
    maxWidth: ['100%', null, '1000px'],
    textAlign: 'center'
  }} data-sentry-element="HeroHeaderSection" data-sentry-component="WellnessHeroHeaderSectionV2" data-sentry-source-file="index.tsx" />;
};